"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ModalWindow = _interopRequireDefault(require("../ModalWindow"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Confirm = /*#__PURE__*/function (_Component) {
  _inherits(Confirm, _Component);

  var _super = _createSuper(Confirm);

  function Confirm(props) {
    var _this;

    _classCallCheck(this, Confirm);

    _this = _super.call(this); // todo need to do something with modalStyles

    _defineProperty(_assertThisInitialized(_this), "checkWindowHeight", function (y) {
      var intViewportHeight = window.innerHeight;

      if (intViewportHeight - y < 75) {
        return y - 150;
      }

      return y - 75;
    });

    _defineProperty(_assertThisInitialized(_this), "checkWindowWidth", function (x) {
      var difX = document.body.clientWidth - x;
      var resX;

      if (x < 140) {
        resX = 0;
      } else if (difX > 280) {
        resX = 140;
      } else if (difX > 0) {
        resX = 280 - difX;
      }

      return x - resX;
    });

    _defineProperty(_assertThisInitialized(_this), "handleAction", function () {
      _this.props.action();

      _this.props.cancel();
    });

    var modalStyles = _objectSpread({}, props.modalStyles);

    if (props.modalCors) {
      modalStyles.position = 'fixed';
      modalStyles.left = _this.checkWindowWidth(props.modalCors[0]);
      modalStyles.top = _this.checkWindowHeight(props.modalCors[1]);
    }

    _this.state = {
      modalStyles: modalStyles
    };
    return _this;
  }

  _createClass(Confirm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          cancel = _this$props.cancel,
          message = _this$props.message,
          confirmText = _this$props.confirmText,
          cancelText = _this$props.cancelText;
      var modalStyles = this.state.modalStyles;
      return /*#__PURE__*/_react["default"].createElement(_ModalWindow["default"], {
        safetyMode: false,
        onClose: cancel,
        modalStyles: modalStyles
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "confirm"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "logo"
      }, message), /*#__PURE__*/_react["default"].createElement("div", {
        className: "control-buttons"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: "button delete",
        onClick: this.handleAction
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "icon-check"
      }), confirmText), /*#__PURE__*/_react["default"].createElement("button", {
        className: "button cancel noMargin",
        onClick: cancel
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "icon-close"
      }), cancelText))));
    }
  }]);

  return Confirm;
}(_react.Component);

Confirm.propTypes = {
  modalStyles: _propTypes["default"].object,
  modalCors: _propTypes["default"].array,
  action: _propTypes["default"].func.isRequired,
  cancel: _propTypes["default"].func.isRequired,
  message: _propTypes["default"].string,
  confirmText: _propTypes["default"].string,
  cancelText: _propTypes["default"].string
};
Confirm.defaultProps = {
  modalStyles: {
    width: 280,
    padding: 0
  },
  modalCors: null,
  message: 'Are you sure?',
  confirmText: 'yes',
  cancelText: 'cancel'
};
var _default = Confirm;
exports["default"] = _default;